import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Contract } from 'app/models/dataPrediction/contract.model';
import { PredictionsService } from 'app/services/predictions.service';
import { EChartsOption } from 'echarts';
import * as moment from 'moment';
import { concatMap } from 'rxjs/operators';
import { areDatesEqualIgnoringTime, calculateNextProducts } from './helpers/product.helper';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-predictions',
  templateUrl: './predictions.component.html',
  styleUrls: ['./predictions.component.scss']
})
export class PredictionsComponent implements OnInit {

  selectedProductInfo;
  selectedDate;
  series : number;
  lastProductionDate: NgbDateStruct;
  filterForm: FormGroup;
  contractsList : Contract[];
  chartOptions: EChartsOption;
  priceCorridors: any[];
  timeSeries: any[];
  productionRuns: any[];
  afterProductionSeries: any[];
  latestProductionId : number;
  availableDates:  NgbDate[] = [];
  loading: boolean = false;
  dataLoaded : boolean = false;
  productsDescription = [];
  lastPrice: number = null;
  priceChange: string = null;

  electricityMonthProducts = [
     {id: 41, name: "Prima lună următoare", commodity : "electricitate", series: 699, timeFrame: 1, code: "M1"},
    {id: 48, name: "A II-a lună următoare", commodity : "electricitate", series: 706, timeFrame: 1, code: "M2"},
    {id: 46, name: "A III-a lună următoare", commodity : "electricitate", series: 704, timeFrame : 1, code: "M3"},
  ]

  electricityQuarterProducts = [
    {id: 31, name: "Primul trimestru următor", commodity : "electricitate", series: 689, timeFrame : 3, code: "Q1"},
    {id: 20, name: "Al II-lea trimestru următor", commodity : "electricitate", series: 678,timeFrame : 3, code: "Q2"},
    {id: 31, name: "Al III-lea trimestru următor", commodity : "electricitate", series: 689,timeFrame :3, code: "Q3"},
  ]

  electricityYearProducts = [
    {id: 50, name: "Primul an următor", commodity : "electricitate", series: 708,timeFrame : 12, code: "Y1"},
    {id: 17, name: "Al II-lea an următor", commodity : "electricitate", series: 675, timeFrame :12, code: "Y2"},
  ]

  gasMonthProducts = [
    {id: 7, name: "Prima lună următoare", commodity : "gaz", series: 629, timeFrame: 1, code: "M1"},
    {id: 79, name: "A II-a lună următoare", commodity : "gaz", series: 630, timeFrame: 1, code: "M2"},
    {id: 80, name: "A III-a lună următoare", commodity : "gaz", series: 631, timeFrame: 1, code: "M3"},
  ]

  gasQuarterProducts = [
    {id: 88, name: "Primul trimestru următor", commodity : "gaz", series: 626, timeFrame: 3, code: "Q1"},
    {id: 86, name: "Al II-lea trimestru următor", commodity : "gaz", series: 628, timeFrame: 3, code: "Q2"},
    {id: 87, name: "Al III-lea trimestru următor", commodity : "gaz", series: 627, timeFrame: 3, code: "Q3"},
  ]

  gasYearProducts = [
    {id: 8, name: "Primul an următor", commodity : "gaz", series: 625, timeFrame: 12, code: "Y1"},
    {id: 9, name: "Al II-lea an următor", commodity : "gaz", series: 623, timeFrame: 12, code: "Y1"},
  ]

  constructor(private predictionsService: PredictionsService) { }

  ngOnInit(): void {
    this.productsDescription = calculateNextProducts();
    const today = new Date();
    this.calculatePriceChange(); // de scos


    this.lastProductionDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
    this.filterForm = new FormGroup({
      contracts: new FormControl(-1, Validators.required),
      selectedDate: new FormControl(this.lastProductionDate, Validators.required)
    }, [])

    this.predictionsService.getContracts().subscribe( data => {
      this.contractsList = data.results
    })

    this.filterForm.get('selectedDate')?.valueChanges.subscribe(value => {
      let changedDate = new Date(value.year, value.month - 1, value.day);
      let currentProductionRun = this.productionRuns.find(run => areDatesEqualIgnoringTime(new Date(run['production_date']), changedDate))
      this.latestProductionId = currentProductionRun.id;
      this.loading = true;
      var oneMonthBefore = new Date(changedDate);
      forkJoin([this.predictionsService.getPriceCorridors(this.series, this.latestProductionId),
        this.predictionsService.getTimeSeries(this.series, new Date(oneMonthBefore.setMonth(oneMonthBefore.getMonth() - 1)), new Date())
      ])
      .subscribe(responses =>
      {

        this.priceCorridors = responses[0];
        this.timeSeries = responses[1].filter(item => item.time <= this.productionRuns.filter(prod => prod.id == this.latestProductionId)[0].production_date);
        this.afterProductionSeries = responses[1].filter(item => item.time >= this.productionRuns.filter(prod => prod.id == this.latestProductionId)[0].production_date);
        this.setChartOptions();
        this.loading = false;
        this.dataLoaded = true;
        this.calculatePriceChange();
      })
    
    });

    this.filterForm.get('contracts')?.valueChanges.subscribe(value => {
      this.predictionsService.getProductionRuns(value.id)
      .pipe(
        concatMap(productions => {
          this.loading = true;
          this.productionRuns = productions;
          this.series = value.series;
          this.convertDates();
          const latestProduction = productions[productions.length - 1]
          this.latestProductionId = latestProduction.id;
          const latestDate = new Date(latestProduction.production_date);
          this.lastProductionDate = {
            year: latestDate.getFullYear(),
            month: latestDate.getMonth() + 1,
            day: latestDate.getDate()
          };
          this.filterForm.controls.selectedDate.setValue(this.lastProductionDate, { emitEvent: false })



          return this.predictionsService.getPriceCorridors(value.series, this.latestProductionId)
        }),
        concatMap(corridors => {
          this.priceCorridors = corridors;
          return this.predictionsService.getTimeSeries(value.series, new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date())
        })
      )
      .subscribe(timeSeries => {
        this.timeSeries = timeSeries.filter(item => item.time <= this.productionRuns.filter(prod => prod.id == this.latestProductionId)[0].production_date);
        this.afterProductionSeries = timeSeries.filter(item => item.time >= this.productionRuns.filter(prod => prod.id == this.latestProductionId)[0].production_date);
        this.setChartOptions();
        this.loading = false;
        this.dataLoaded = true;
        this.calculatePriceChange();
      })

    });
  }

  get selectedProduct() {
    this.selectedProductInfo = this.filterForm.value.contracts;
    return {
      name:  this.selectedProductInfo.name,
      description : this.productsDescription.find(item => item.code ==  this.selectedProductInfo.code)?.product
    }
  }

  select(item: any){
    console.log(item);
  }

  calculatePriceChange(){
    if(this.dataLoaded){
    let lastValue = this.timeSeries[this.timeSeries.length - 1].value;
    let lastLastValue = this.timeSeries[this.timeSeries.length - 2].value;
    let diff = lastValue - lastLastValue;
    this.lastPrice = lastValue
    let percent = (diff / lastValue ) * 100;
    this.priceChange = `${diff >= 0 ? '+' : ''}${percent.toFixed(2)}%`
    }
  }

  private setChartOptions(){

    var allDates: any[] = this.priceCorridors.map(value => value.horizon_date)
    allDates = allDates.concat(this.timeSeries.map(value => value.time))
    allDates = allDates.concat(this.afterProductionSeries.map(value => value.time))
    allDates = allDates.sort().filter(this.onlyUnique);
    var lastIndexOfTimeSeries = this.timeSeries[this.timeSeries.length - 1];
    var max90Precent: any[] = [];
    var min90Precent: any[] = [];
    var max70Precent:any[] =[] ;
    var  min70Precent: any[] = []
    var max50Precent: any[] =[]
    var min50Precent: any[]=[];

    max90Precent.push([lastIndexOfTimeSeries.time, 0])
    min90Precent.push([lastIndexOfTimeSeries.time, lastIndexOfTimeSeries.value])
    // max70Precent.push([lastIndexOfTimeSeries.time, 0])
    // min70Precent.push([lastIndexOfTimeSeries.time, lastIndexOfTimeSeries.value])
    max50Precent.push([lastIndexOfTimeSeries.time, 0])
    min50Precent.push([lastIndexOfTimeSeries.time, lastIndexOfTimeSeries.value])

    max90Precent = max90Precent.concat( this.priceCorridors.filter(value => value.quantile === 0.9).map(value => {
      return [value.horizon_date, value.max_value - value.min_value];
    }))
    min90Precent = min90Precent.concat(this.priceCorridors.filter(value => value.quantile === 0.9).map(value => {
      return [value.horizon_date, value.min_value];
    }))

    // max70Precent = max70Precent.concat(this.priceCorridors.filter(value => value.quantile === 0.7).map(value => {
    //   return [value.horizon_date, value.max_value - value.min_value];
    // }))
    // min70Precent = min70Precent.concat(this.priceCorridors.filter(value => value.quantile === 0.7).map(value => {
    //   return [value.horizon_date, value.min_value];
    // }))

    max50Precent = max50Precent.concat(this.priceCorridors.filter(value => value.quantile === 0.5).map(value => {
      return [value.horizon_date, value.max_value - value.min_value];
    }))
    min50Precent = min50Precent.concat(this.priceCorridors.filter(value => value.quantile === 0.5).map(value => {
      return [value.horizon_date, value.min_value];
    }))


    // max90Precent.push([lastIndexOfTimeSeries.time, 0])
    // min90Precent.push([lastIndexOfTimeSeries.time, lastIndexOfTimeSeries.value])
    // max70Precent.push([lastIndexOfTimeSeries.time, 0])
    // min70Precent.push([lastIndexOfTimeSeries.time, lastIndexOfTimeSeries.value])
    // max50Precent.push([lastIndexOfTimeSeries.time, 0])
    // min50Precent.push([lastIndexOfTimeSeries.time, lastIndexOfTimeSeries.value])

    this.chartOptions = {
      title: {
      },
      tooltip: {
  
      },
      legend: {
        show: false
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: allDates
        }
      ],
      yAxis: [
        {
          type: 'value',
          min: this.findMinValue(this.priceCorridors),
          max: this.findMaxValue(this.priceCorridors)
        }
      ],
        series: [
          
  
          {
            name: 'min09',
            type: 'line',
            silent: true,
            smooth: true,
            data: min90Precent,
            lineStyle: {
              opacity: 0
            },
            stack: '90probability',
            symbol: 'none',
            triggerLineEvent: true
          },
          {
            name: 'max09',
            type: 'line',
            smooth: true,
            data: max90Precent,
            silent: true,
            lineStyle: {
              opacity: 0
            },
            areaStyle: {
              color: '#FF0000'
            },
            stack: '90probability',
            symbol: 'none',
            triggerLineEvent: true
  
          },
          {
            name: 'initialValue',
            type: 'line',
            showSymbol: false,
            smooth: true,
            lineStyle: {
              type: 'dotted',
            },
            data: this.timeSeries.map(value => [value.time , value.value])
          },
          {
            name: 'afterProd',
            type: 'line',
            showSymbol: false,
            smooth: true,
            lineStyle: {
              color: 'black',
              type: 'dotted'
            },
            data: this.afterProductionSeries.map(value => [value.time , value.value])
          },
          // {
          //   name: 'min07',
          //   type: 'line',
          //   silent: true,
          //   smooth: true,
          //   data: min70Precent,
          //   lineStyle: {
          //     opacity: 0
          //   },
          //   stack: '70probability',
          //   symbol: 'none',
          //   triggerLineEvent: false
  
          // },
          // {
          //   name: 'max07',
          //   type: 'line',
          //   silent: true,
          //   smooth: true,
          //   data: max70Precent,
          //   lineStyle: {
          //     opacity: 0
          //   },
          //   areaStyle: {
          //     opacity: 0.5,
          //     color: '#00008B'
          //   },
          //   stack: '70probability',
          //   symbol: 'none',
          //   triggerLineEvent: false
  
          // },
          {
            name: 'min05',
            type: 'line',
            silent: true,
            smooth: true,
            data: min50Precent,
            lineStyle: {
              opacity: 0
            },
            stack: '50probability',
            symbol: 'none',
            triggerLineEvent: false
  
          },
          {
            name: 'max05',
            type: 'line',
            silent: true,
            smooth: true,
            data: max50Precent,
            lineStyle: {
              opacity: 0
            },
            areaStyle: {
              opacity: 0.3,
              color: '#00FFFF'
            },
            stack: '50probability',
            symbol: 'none',
            triggerLineEvent: false
  
          },
        ]
      };

  }

  onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  findMaxValue(items: any[]): number | undefined {
    if (!items.length) return undefined;
    let max = Math.max(...items.map(item => item.max_value));
    return Math.ceil(max);
  };

  
  findMinValue(items: any[]): number | undefined {
    if (!items.length) return undefined;
    let min = Math.min(...items.map(item => item.min_value));
    return Math.floor(min);
  }

  isLater(date1: string, date2: string): boolean {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return d1.getTime() > d2.getTime();
  }

  convertDates() {
    this.availableDates = this.productionRuns.map(run => {
      const date = new Date(run["production_date"]); // Convertim ISO în Date
      return new NgbDate (
        date.getUTCFullYear(),
        date.getUTCMonth() + 1,
        date.getUTCDate()
      );
    });
  }

  disableUnavailableDates = (date: NgbDate): boolean => {
    return !this.availableDates.some(d =>
      d.year === date.year &&
      d.month === date.month &&
      d.day === date.day
    );
  };
}
